import React from 'react';

function initialsFor(name) {
	const parts = String(name || '')
		.trim()
		.split(/\s+/)
		.filter(Boolean);
	if (!parts.length) return '?';
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

const SIZE_CLASSES = {
	sm: 'h-9 w-9 text-xs',
	md: 'h-11 w-11 text-sm',
	lg: 'h-14 w-14 text-base'
};

export default function UserAvatar({ name, size = 'md', className = '' }) {
	const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
	return (
		<div
			className={`${sizeClass} shrink-0 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white font-semibold shadow-sm ${className}`}
			aria-hidden
		>
			{initialsFor(name)}
		</div>
	);
}
